// All or portions of this file Copyright © 2019 Amazon Web Services, Inc. or its affiliates or licensors.
// All rights reserved. For full license terms and conditions, please see the LICENSE file at the root of
// this distribution (the "License") or go to https://content.sumerian.amazonaws.com/engine/latest/license.txt.
// All use of the software is governed by the License. All materials are made available on an "AS IS" BASIS, WITHOUT
// WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. Do not remove or modify any license notices.
import AudioProcessor from 'core/sound/AudioProcessor';

class LexAudioProcessor extends AudioProcessor {
  /**
   * Processes the audio into an Amazon Lex supported format and sample rate.
   *
   * @returns {Blob} The encoded audio.
   */
  process() {
    const downsampledAudio = this.downsampleAudio(LexAudioProcessor.targetSampleRate);
    const encodedAudio = this.encodeWAV(downsampledAudio, LexAudioProcessor.targetSampleRate);
    this.floatTo16BitPCM(encodedAudio, 44, downsampledAudio);

    return new Blob([encodedAudio], {type: 'application/octet-stream'});
  }
}

Object.defineProperty(LexAudioProcessor, 'targetSampleRate', {
  configurable: false,
  enumerable: true,
  writable: false,
  value: 16000
});


export default LexAudioProcessor;
